MS = window.MS || {};

(function($) {
	MS.splash = {
		player: [],
		isVideoPlaying: false,
		apiLoaded: false,
		$window: $(window),
		$splash: $('.ms-masterbrand-splash'),
		currentItem: 0,
		fullVideo: 0,

		init: function() {
			var self = this;
			var $splash = self.$splash;
			$window = $(window);
			self.initPlayer();

			$splash.on('click', 'a.continue', function(e) {
				e.preventDefault();
				self.exitSplash();
			});
			$splash.on('click', 'a.btn', function(e) {
				e.preventDefault();
				MS.splash.currentItem = $(this).data('item');
				self.showFullVideo( MS.splash.currentItem  );
			});
			$splash.on('click', 'a.close', function(e) {
				self.backToTeaser( MS.splash.currentItem );
			});

			self.handleParallax();
		},
		initPlayer: function() {
      var teasers = $('.ms-masterbrand-splash__player');

			if (typeof(YT) === 'undefined' || typeof(YT.Player) === 'undefined') {
				window.onYouTubePlayerAPIReady = function() {
					MS.youtubeAPIReady = true;
          MS.splash.apiLoaded = true;

					teasers.each(function(i){
						if( $('#ms-masterbrand-splash__player-' + i).data('teaser') !== '' ) {
							MS.splash.player[i] = new YT.Player('ms-masterbrand-splash__player-' + i, {events: {'onReady': MS.splash.onPlayerReady, 'onStateChange': MS.splash.onPlayerStateChange }, playerVars: MS.splash.getPlayerSettings()});
						}
					});
				};
			} else {
				teasers.each(function(i){
					MS.splash.player[i] = new YT.Player('ms-masterbrand-splash__player-' + i, {events: {'onReady': MS.splash.onPlayerReady, 'onStateChange': MS.splash.onPlayerStateChange }, playerVars: MS.splash.getPlayerSettings()});
				});
			}
		},
		onPlayerReady: function() {
      var teasers = $('.ms-masterbrand-splash__player');
			if( !MS.splash.isVideoPlaying ) {
				teasers.each(function(i){
          var $player = $('#ms-masterbrand-splash__player-' + i);
					MS.splash.player[i].loadVideoById({'videoId': $player.data('teaser'), 'suggestedQuality': 'hd720'});
          MS.splash.player[i].mute();
				});
			} else {
        teasers.each(function(i){
          var $player = $('#ms-masterbrand-splash__player-' + i);
          if( $(window).width() <= 860 ) {
            MS.splash.player[i].cueVideoById({'videoId': $player.data('full'), 'suggestedQuality': 'hd720'});
          } else {
            MS.splash.player[i].loadVideoById({'videoId': $player.data('full'), 'suggestedQuality': 'hd720'});
          }
          if( $player.data('mute') ) {
            MS.splash.player[i].mute();
          } else {
            MS.splash.player[i].unMute();
          }
        });
			}

			if ( MS.splash.fullVideo === 1 ) {
				MS.splash.player[MS.splash.currentItem].unMute();
			}
		},
		onPlayerStateChange: function(e) {
			var teasers = $('.ms-masterbrand-splash__player');

			if(e.data === 0 && !MS.splash.isVideoPlaying) {
				i = 0;
				teasers.each(function(){
					MS.splash.player[i].seekTo(0);
					i++;
				});
			} else if(e.data === 0 && MS.splash.isVideoPlaying) {
				MS.splash.backToTeaser();
			}
		},
		vidRescale: function() {
			var teasers = $('.ms-masterbrand-splash__player');
			var w = $(window).width(),
			h = $(window).height();

			i = 0;
			teasers.each(function(){
				$('#ms-masterbrand-splash__player-' + i).height(h);

				if (w/h > 16/9) {
					MS.splash.player[i].setSize(w, w/16*9);
					$('.ms-masterbrand-splash__player-wrapper .screen').css({'left': '0px'});
				} else {
					MS.splash.player[i].setSize(h/9*16, h);
					$('.ms-masterbrand-splash__player-wrapper .screen').css({'left': -($('.ms-masterbrand-splash__player-wrapper .screen').outerWidth()-w)/2});
				}
				i++;
			});
		},
		closeSplash: function() {
			var $splash = $('.ms-masterbrand-splash');
			$splash.addClass('hide');
			$('body').addClass('splash-deactivated');
			MS.splash.fullVideo = 0;
		},
		exitSplash: function() {
			var splash = document.getElementById('ms-splash');
			var scrollTop = splash.offsetHeight - 60;
			var $body = $("html, body");

			if ($('body.page-template-page-foodwaste').length){
				var $nextModule = $('#ms-splash').next('section');
				scrollTop = $nextModule.offset().top - 120;
			}

			$body.stop().animate({scrollTop: scrollTop}, 1200, 'swing', function() {
				// Do somethin here
			});
		},
		getPlayerSettings: function() {
			var settings = '';

			if( !MS.splash.isVideoPlaying ) {
				settings = {
					autoplay: 0,
					autohide: 1,
					modestbranding: 0,
					rel: 0,
					showinfo: 0,
					controls: 0,
					disablekb: 1,
					enablejsapi: 0,
					iv_load_policy: 3,
					loop: 1
				};
			} else {
				settings = {
					autoplay: 1,
					autohide: 1,
					modestbranding: 0,
					rel: 0,
					showinfo: 0,
					controls: 0,
					disablekb: 1,
					enablejsapi: 0,
					iv_load_policy: 3,
					loop: 1
				};
				if( $(window).width() <= 860 ) {
					settings.autoplay = 0;
					settings.controls = 1;
				}
			}

			return settings;
		},
		showFullVideo: function( _item ) {
			MS.splash.fullVideo = 1;
			MS.splash.currentItem = _item;
      var $splash = $('.ms-masterbrand-splash');
      var _playerWrapper = 'ms-masterbrand-splash__player-' + _item;
      var $player = $('#' + _playerWrapper);
      var slickCarousel = $('.ms-splash--carousel');

			$splash.addClass('show-full-video');
			$splash = $('.ms-masterbrand-splash.show-full-video');

			$splash.on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function(event) {
				event.preventDefault();

				if( !MS.splash.isVideoPlaying ) {
					$( $player.parent() ).html('<div id="' + _playerWrapper + '" class="screen ms-masterbrand-splash__player" data-teaser="'+$player.data('teaser')+'" data-full="'+$player.data('full')+'"></div>');
          MS.splash.isVideoPlaying = true;
          MS.splash.player[_item] = new YT.Player(_playerWrapper, {events: {'onReady': MS.splash.onPlayerReady, 'onStateChange': MS.splash.onPlayerStateChange}, playerVars: MS.splash.getPlayerSettings()});
					$('.ms-masterbrand-splash__content').hide();
				}

				if ( MS.splash.isVideoPlaying && slickCarousel.length > 0 ) {
					// Once the fullscreen video shows, pause the slick slide
					slickCarousel.slick('slickPause');
				}
			});
		},
		backToTeaser: function( item ) {
			MS.splash.fullVideo = 0;
			var $splash = $('.ms-masterbrand-splash');
			var $player = $('#ms-masterbrand-splash__player-' + item );
			var slickCarousel = $('.ms-splash--carousel');

			// Always resume the slick slide when returning to the teaser BG
			slickCarousel.slick('slickPlay');

			$splash.unbind('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd');
			MS.splash.isVideoPlaying = false;
			$('.ms-masterbrand-splash__content').show();
			$splash.removeClass('show-full-video');
			$( $player.parent() ).html('<div id="ms-masterbrand-splash__player-' + item + '" class="screen ms-masterbrand-splash__player" data-teaser="'+$player.data('teaser')+'" data-full="'+$player.data('full')+'"></div>');

			MS.splash.player[item] = new YT.Player('ms-masterbrand-splash__player-' + item, {events: {'onReady': MS.splash.onPlayerReady, 'onStateChange': MS.splash.onPlayerStateChange }, playerVars: MS.splash.getPlayerSettings()});
		},
		handleParallax: function() {
			var self = this;
			self.$window.on('scroll', function(event) {
				var t = self.$window.scrollTop();
				var h = self.$window.height();
				var p = t / h;

				if( p >= 1 && MS.splash.isVideoPlaying ) {
					MS.splash.backToTeaser();
				}

				if( p <= 1) {
					if( self.$splash.hasClass('hide') ) {
						self.$splash.removeClass('hide');
					}

					if(!$('body.page-template-page-foodwaste').length){
						self.$splash.find('.ms-masterbrand-splash__content').first().css('opacity', 1 - (p * 2));
					}


					p = (p * 100) / 2;
					self.$splash.css('transform', 'translateY(-' + p + '%)');
				} else {
					if( !self.$splash.hasClass('hide') ) {
						self.$splash.addClass('hide');

						// Weird that backToTeaser is not resuming its autoplay if it comes from here.
						// So to fix, we explicitly resume it here, then call the backToTeaser
						var slickCarousel = $('.ms-splash--carousel');
						slickCarousel.slick('slickPlay');
						MS.splash.backToTeaser(MS.splash.currentItem);
					}
				}

			});
		}
	};
})(jQuery);

jQuery(document).ready(function($) {
	MS.splash.init();
});
